module.exports = __webpack_public_path__ + "img/i_mail.6bcaf070.svg";